import React from "react";
import { privatePaths } from "../../paths";
import { RouteObject } from "react-router";
import ProtectedRoute from ".";

// Application routes
const AdminDashboard = React.lazy(() => import("features/adminDashboard/pages/AdminDashboard"));
const AdminUserManagement = React.lazy(() => import("features/adminUserManagement/pages/AdminUserManagement"));
const TransactionLogs = React.lazy(() => import("features/transactionLogs/pages/TransactionLogs"));

const protectedRoutes: RouteObject[] = [
  {
    path: "/",
    children: [
      {
        path: privatePaths.adminDashboard,
        element: (
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: privatePaths.adminUserManagement,
        element: (
          <ProtectedRoute>
            <AdminUserManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: privatePaths.transactionLogs,
        element: (
          <ProtectedRoute>
            <TransactionLogs />
          </ProtectedRoute>
        ),
      },
    ],
  },
  // TODO: Redirect user to 404 page not found page once its ready
];
export default protectedRoutes;
